export default {
  activateLandingPageTitle: 'Събития',
  activateProductCardTitle: 'Събития',
  activateProductPageTitle: 'Резервирай събития',
  allProductsLandingPageTitle: 'Резервирай уникални преживявания',
  apply: 'Приложи',
  buyTickets: 'Купи билети',
  cancel: 'Отказ',
  clear: 'Изчисти',
  clearFilters: 'Изчисти филтрите',
  discoverExperiences: 'Открийте преживявания',
  exclusive: 'Ексклузивно',
  experience: 'преживяване',
  experiencePhotoOfListing:
    'Снимка на преживяване {{photoNumber}} от обява {{listingTitle}}',
  experiences: 'преживявания',
  filterExperiences: 'Филтриране на преживявания',
  fromListingCard: 'От',
  hostedBy: 'Домакин',
  hostLandingPageTitle: 'Местни преживявания',
  hostProductCardTitle: 'Местни преживявания',
  hostProductPageTitle: 'Резервирай местни преживявания',
  landingPageTitle: 'Резервирай уникални преживявания',
  mainLandingPageTitle: 'Всички преживявания',
  more: 'Повече',
  noExperiencesFound: 'Не са намерени преживявания',
  noExperiencesFoundFor: 'Не са намерени преживявания за',
  experiencesFoundCount: '{{count}} намерени преживявания',
  profileImageOfHost: 'Профилна снимка на домакин {{hostName}}',
  reserve: 'Резервирай',
  reserveLandingPageTitle: 'Дейности и удобства',
  reserveProductCardTitle: 'Дейности',
  reserveProductPageTitle: 'Резервирай дейности и удобства',
  resultsPageTitle: 'Резервирай преживявания и дейности',
};
